module.exports = __webpack_public_path__ + "img/admin.6c01fda5.svg";